// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__2Puxn","input":"Checkbox_input__xae-y","check":"Checkbox_check__lGQxI","label":"Checkbox_label__shLrj","filled":"Checkbox_filled__SvO1A"};